import { AnswerBlock } from '@/components/create/answer/AnswerBlock';
import { AnswerFeedbackSent } from './create/answer/AnswerFeedbackSent';
import { AnswerSuccess } from './create/answer/AnswerSuccess';
import { CardFormVariant } from '@/types/card/CardFormVariant';
import { CardPayedErrorPage } from '@/components/main/error/CardPayedErrorPage';
import { CardRefillErrorPage } from './main/error/CardRefillErrorPage';
import { CardSuccess } from './create/card/CardSuccess';
import { CreateCardBlockMobile } from './create/card/CreateCardBlockMobile';
import { CreateCardsBlock } from './create/card/CreateCardsBlock';
import { CreateFormAuthorMobile } from '@/components/create/letter/CreateFormAuthorMobile';
import { CreateFormClient } from '@/components/create/letter/CreateFormClient';
import { CreateFormDepartment } from '@/components/create/letter/CreateFormDepartment';
import { CreateFormLetter } from '@/components/create/letter/CreateFormLetter';
import { CreateFormReceiver } from '@/components/create/letter/CreateFormReceiver';
import { CreateFormSender } from '@/components/create/letter/CreateFormSender';
import { DepartmentChangeForm } from '@/components/letter/department/DepartmentChangeForm';
import { DepartmentChangeFormLetter } from '@/components/letter/department/DepartmentChangeFormLetter';
import { DepartmentPage } from './help/departments/DepartmentPage';
import { Departments } from '@/components/help/departments/Departments';
import { FaqBlock } from './help/FaqBlock';
import { FeedbackBlock } from '@/components/help/FeedbackBlock';
import { LetterBlock } from '@/components/create/letter/LetterBlock';
import { LetterPayedErrorPage } from '@/components/main/error/LetterPayedErrorPage';
import { LetterSuccess } from '@/components/create/letter/LetterSuccess';
import { MainCreateFormPayment } from '@/components/create/main/letter/MainCreateFormPayment';
import { MainCreateFormPaymentMobile } from '@/components/create/main/letter/MainCreateFormPaymentMobile';
import { MobileDepartmentChangeForm } from '@/components/letter/department/MobileDepartmentChangeForm';
import { MobileRegionsList } from '@/components/help/departments/MobileRegionsList';
import { Navigate, RouteObject } from 'react-router-dom';
import {
  ROUTE_CREATE,
  ROUTE_CREATE_ANSWER,
  ROUTE_CREATE_ANSWER_DEPARTMENT,
  ROUTE_CREATE_ANSWER_FEEDBACK,
  ROUTE_CREATE_ANSWER_PAYMENT,
  ROUTE_CREATE_ANSWER_SENDER,
  ROUTE_CREATE_FEEDBACK_SUCCESS,
  ROUTE_CREATE_LETTER,
  ROUTE_CREATE_LETTER_AUTHOR,
  ROUTE_CREATE_LETTER_CLIENT,
  ROUTE_CREATE_LETTER_DEPARTMENT,
  ROUTE_CREATE_LETTER_PAYMENT,
  ROUTE_CREATE_LETTER_SUCCESS,
  ROUTE_CREATE_LETTER_TEXT,
  ROUTE_CREATE_REPLY,
  ROUTE_CREATE_REPLY_ANSWER,
  ROUTE_CREATE_REPLY_LETTER,
  ROUTE_CREATE_REPLY_LETTER_ID,
  ROUTE_ERROR,
  ROUTE_ERROR_CARD_PAYED,
  ROUTE_ERROR_CARD_REFILL,
  ROUTE_ERROR_LETTER_PAYED,
  ROUTE_HELP,
  ROUTE_HELP_DEPARTMENT,
  ROUTE_HELP_FAQ,
  ROUTE_HELP_FEEDBACK,
  ROUTE_HELP_FEEDBACK_NUMBER,
  ROUTE_HELP_REGIONS,
  ROUTE_HELP_REGIONS_CHAR,
  ROUTE_HELP_REGIONS_ID,
  ROUTE_HELP_WORK,
  ROUTE_INBOX,
  ROUTE_MAIN,
  ROUTE_MAIN_CARD,
  ROUTE_MAIN_CARD_CREATED,
  ROUTE_MAIN_CARD_PAYED,
  ROUTE_MAIN_CARD_REFILLED,
  ROUTE_MAIN_CREATE_ANSWER,
  ROUTE_MAIN_CREATE_ANSWER_AUTHOR,
  ROUTE_MAIN_CREATE_ANSWER_CLIENT,
  ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT,
  ROUTE_MAIN_CREATE_ANSWER_FEEDBACK,
  ROUTE_MAIN_CREATE_ANSWER_PAYMENT,
  ROUTE_MAIN_CREATE_ANSWER_RECEIVER,
  ROUTE_MAIN_CREATE_FEEDBACK_SUCCESS,
  ROUTE_MAIN_CREATE_LETTER,
  ROUTE_MAIN_CREATE_LETTER_AUTHOR,
  ROUTE_MAIN_CREATE_LETTER_CLIENT,
  ROUTE_MAIN_CREATE_LETTER_DEPARTMENT,
  ROUTE_MAIN_CREATE_LETTER_PAYMENT,
  ROUTE_MAIN_CREATE_LETTER_RECEIVER,
  ROUTE_MAIN_CREATE_LETTER_SUCCESS,
  ROUTE_MAIN_CREATE_LETTER_TEXT,
  ROUTE_REDIRECT,
  ROUTE_REDIRECT_DEPARTMENT,
  ROUTE_REDIRECT_LETTER,
  ROUTE_REDIRECT_SUCCESS,
} from '@/app/routes';
import { RegionsBlock } from './help/RegionsBlock';
import { ReplyBlock } from '@/components/create/reply/ReplyBlock';
import { TabRegionsList } from '@/components/help/departments/TabRegionsList';
import { UserDTO } from '@/types/user/UserDTO';
import { WideRegionsList } from '@/components/help/departments/WideRegionsList';
import { WorkBlock } from '@/components/help/WorkBlock';
import MobileRegionsCharacter from '@/components/help/departments/MobileRegionsCharacter';
import React from 'react';

export const renderMainLetterBlock = (isMobile: boolean, authUser?: UserDTO): RouteObject[] => {
  const routes: RouteObject[] = [];

  if (authUser) {
    routes.push({
      path: ROUTE_MAIN_CREATE_LETTER_RECEIVER,
      element: <CreateFormReceiver type={'letter'} />,
    });
  }

  routes.push(
    {
      path: ROUTE_MAIN_CREATE_LETTER_DEPARTMENT,
      element: (
        <CreateFormDepartment
          tittle={'Шаг 1 из 4: Выберите учреждение'}
          mobileTittle={'1/5: Выберите учреждение'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_CLIENT}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER_CLIENT,
      element: isMobile ? (
        <CreateFormSender
          mobileTittle={'2/5: Введите данные получателя'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_AUTHOR}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 4: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
          senderTittle={'Данные отправителя'}
          recipientTittle={'Данные получателя'}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER_AUTHOR,
      element: isMobile ? (
        <CreateFormAuthorMobile
          mobileTittle={'3/5: Введите данные отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_CLIENT}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_CLIENT}
          isMobile={isMobile}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 4: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
          senderTittle={'Данные отправителя'}
          recipientTittle={'Данные получателя'}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER_TEXT,
      element: (
        <CreateFormLetter
          tittle={'Шаг 3 из 4: Напишите письмо'}
          mobileTittle={'4/5: Напишите письмо'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_PAYMENT}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_AUTHOR}
          previousFormLabel={isMobile ? 'Шаг 3' : 'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER_PAYMENT,
      element: isMobile ? (
        <MainCreateFormPaymentMobile
          mobileTittle={'5/5: Оплатите письмо'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_SUCCESS}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_TEXT}
          previousFormLabel={'Шаг 4'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ) : (
        <MainCreateFormPayment
          tittle={'Шаг 4 из 4: Оплатите письмо'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_SUCCESS}
          previousFormPath={ROUTE_MAIN_CREATE_LETTER_TEXT}
          previousFormLabel={'Шаг 3'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER_SUCCESS,
      element: <LetterSuccess isMobile={isMobile} />,
    },
    {
      path: ROUTE_MAIN_CREATE_LETTER,
      element: (
        <Navigate
          to={authUser ? ROUTE_MAIN_CREATE_LETTER_RECEIVER : ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          replace={true}
        />
      ),
    },
  );

  return routes;
};

export const renderDepartmentChangeBlock = (isMobile: boolean): RouteObject[] => {
  return [
    {
      path: ROUTE_REDIRECT_LETTER,
      element: isMobile ? (
        <DepartmentChangeFormLetter
          mobileTittle={'1/2: Введите данные о письме'}
          nextFormPath={ROUTE_REDIRECT_DEPARTMENT}
          errorRedirectPath={ROUTE_REDIRECT_LETTER}
          isMobile={isMobile}
        />
      ) : (
        <DepartmentChangeForm
          tittle={'Перенаправить письмо в другое учреждение'}
          errorRedirectPath={ROUTE_REDIRECT_LETTER}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_REDIRECT_DEPARTMENT,
      element: isMobile ? (
        <MobileDepartmentChangeForm
          mobileTittle={'2/2: Выберите учреждение'}
          nextFormPath={ROUTE_REDIRECT_SUCCESS}
          previousFormPath={ROUTE_REDIRECT_LETTER}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_REDIRECT_LETTER}
          isMobile={isMobile}
        />
      ) : (
        <DepartmentChangeForm
          tittle={'Перенаправить письмо в другое учреждение'}
          errorRedirectPath={ROUTE_REDIRECT_LETTER}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_REDIRECT,
      element: <Navigate to={ROUTE_REDIRECT_LETTER} replace={true} />,
    },
  ];
};

export const renderMainAnswerBlock = (isMobile: boolean, authUser?: UserDTO): RouteObject[] => {
  const routes = [];

  if (authUser) {
    routes.push({
      path: ROUTE_MAIN_CREATE_ANSWER_RECEIVER,
      element: <CreateFormReceiver type={'answer'} />,
    });
  }

  routes.push(
    {
      path: ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT,
      element: (
        <CreateFormDepartment
          tittle={'Шаг 1 из 3: Выберите учреждение'}
          mobileTittle={'1/4: Выберите учреждение'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_AUTHOR}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_ANSWER_AUTHOR,
      element: isMobile ? (
        <CreateFormSender
          mobileTittle={'2/4: Введите данные отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_CLIENT}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          fromCreateAnswer={true}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 3: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_PAYMENT}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          recipientTittle={'Данные отправителя'}
          senderTittle={'Данные получателя'}
          fromCreateAnswer={true}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_ANSWER_CLIENT,
      element: isMobile ? (
        <CreateFormAuthorMobile
          mobileTittle={'3/4: Введите данные получателя'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_PAYMENT}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_AUTHOR}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          fromCreateAnswer={true}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 3: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_PAYMENT}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_AUTHOR}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          recipientTittle={'Данные отправителя'}
          senderTittle={'Данные получателя'}
          fromCreateAnswer={true}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_ANSWER_PAYMENT,
      element: isMobile ? (
        <MainCreateFormPaymentMobile
          mobileTittle={'4/4: Оплатите ответ'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_CLIENT}
          previousFormLabel={'Шаг 3'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          fromCreateAnswer={true}
        />
      ) : (
        <MainCreateFormPayment
          tittle={'Шаг 3 из 3: Оплатите ответ'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_AUTHOR}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          fromCreateAnswer={true}
        />
      ),
    },
    {
      path: ROUTE_MAIN_CREATE_ANSWER_FEEDBACK,
      element: <AnswerSuccess isMobile={isMobile} />,
    },
    {
      path: ROUTE_MAIN_CREATE_FEEDBACK_SUCCESS,
      element: <AnswerFeedbackSent />,
    },
    {
      path: ROUTE_MAIN_CREATE_ANSWER,
      element: (
        <Navigate
          to={authUser ? ROUTE_MAIN_CREATE_ANSWER_RECEIVER : ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          replace={true}
        />
      ),
    },
  );

  return routes;
};

export const renderMainCardBlock = (isMobile: boolean): RouteObject[] => {
  return [
    {
      path: ROUTE_MAIN_CARD,
      element: isMobile ? <CreateCardBlockMobile /> : <CreateCardsBlock />,
    },
    {
      path: ROUTE_MAIN_CARD_CREATED,
      element: <CardSuccess variant={CardFormVariant.CREATED} isMobile={isMobile} />,
    },
    {
      path: ROUTE_MAIN_CARD_PAYED,
      element: <CardSuccess variant={CardFormVariant.PAYED} isMobile={isMobile} />,
    },
    {
      path: ROUTE_MAIN_CARD_REFILLED,
      element: <CardSuccess variant={CardFormVariant.REFILLED} isMobile={isMobile} />,
    },
    {
      path: '*',
      element: <Navigate to={ROUTE_MAIN_CARD} replace={true} />,
    },
  ];
};

export const renderHelpBlock = (isMobile: boolean, isPad: boolean): RouteObject[] => {
  const renderRegionsBlock = (): RouteObject[] => [
    {
      path: ROUTE_HELP_REGIONS,
      element: isMobile || isPad ? isMobile ? <MobileRegionsList /> : <TabRegionsList /> : <WideRegionsList />,
    },
    {
      path: ROUTE_HELP_REGIONS_CHAR,
      element: <MobileRegionsCharacter />,
    },
    {
      path: ROUTE_HELP_REGIONS_ID,
      element: <Departments />,
    },
  ];

  return [
    {
      path: ROUTE_HELP_WORK,
      element: <WorkBlock />,
    },
    {
      path: ROUTE_HELP_FAQ,
      element: <FaqBlock />,
    },
    {
      element: <RegionsBlock />,
      children: renderRegionsBlock(),
    },
    {
      path: ROUTE_HELP_DEPARTMENT,
      element: <DepartmentPage />,
    },
    { path: ROUTE_HELP_FEEDBACK, element: <FeedbackBlock /> },
    { path: ROUTE_HELP_FEEDBACK_NUMBER, element: <FeedbackBlock /> },
    {
      path: ROUTE_HELP,
      element: <Navigate to={ROUTE_HELP_WORK} replace={true} />,
    },
  ];
};

export const renderErrorBlock = (): RouteObject[] => {
  return [
    {
      path: ROUTE_ERROR_LETTER_PAYED,
      element: <LetterPayedErrorPage />,
    },
    {
      path: ROUTE_ERROR_CARD_REFILL,
      element: <CardRefillErrorPage />,
    },
    {
      path: ROUTE_ERROR_CARD_PAYED,
      element: <CardPayedErrorPage />,
    },
    {
      path: ROUTE_ERROR,
      element: <Navigate to={ROUTE_MAIN} replace={true} />,
    },
  ];
};

export const renderProfileLetterBlock = (isMobile: boolean): RouteObject[] => {
  const renderLetterBlock = (): RouteObject[] => [
    {
      path: ROUTE_CREATE_LETTER_DEPARTMENT,
      element: (
        <CreateFormDepartment
          tittle={'Шаг 1 из 4: Выберите учреждение'}
          mobileTittle={'1/5: Выберите учреждение'}
          previousFormPath={ROUTE_INBOX}
          previousFormLabel={'Входящие'}
          nextFormPath={ROUTE_CREATE_LETTER_CLIENT}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_CREATE_LETTER_CLIENT,
      element: isMobile ? (
        <CreateFormSender
          mobileTittle={'2/5: Введите данные получателя'}
          nextFormPath={ROUTE_CREATE_LETTER_AUTHOR}
          previousFormPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 4: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
          senderTittle={'Данные отправителя'}
          recipientTittle={'Данные получателя'}
        />
      ),
    },
    {
      path: ROUTE_CREATE_LETTER_AUTHOR,
      element: isMobile ? (
        <CreateFormAuthorMobile
          mobileTittle={'3/5: Введите данные отправителя'}
          nextFormPath={ROUTE_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_CREATE_LETTER_CLIENT}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_CREATE_LETTER_CLIENT}
          isMobile={isMobile}
        />
      ) : (
        <CreateFormClient
          tittle={'Шаг 2 из 4: Введите данные получателя и отправителя'}
          nextFormPath={ROUTE_CREATE_LETTER_TEXT}
          previousFormPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
          senderTittle={'Данные отправителя'}
          recipientTittle={'Данные получателя'}
        />
      ),
    },
    {
      path: ROUTE_CREATE_LETTER_TEXT,
      element: (
        <CreateFormLetter
          tittle={'Шаг 3 из 4: Напишите письмо'}
          mobileTittle={'4/5: Напишите письмо'}
          nextFormPath={ROUTE_CREATE_LETTER_PAYMENT}
          previousFormPath={ROUTE_CREATE_LETTER_AUTHOR}
          previousFormLabel={isMobile ? 'Шаг 3' : 'Шаг 2'}
          errorRedirectPath={ROUTE_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_CREATE_LETTER_PAYMENT,
      element: isMobile ? (
        <MainCreateFormPaymentMobile
          mobileTittle={'5/5: Оплатите письмо'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_SUCCESS}
          previousFormPath={ROUTE_CREATE_LETTER_TEXT}
          previousFormLabel={'Шаг 4'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
          isMobile={isMobile}
        />
      ) : (
        <MainCreateFormPayment
          tittle={'Шаг 4 из 4: Оплатите письмо'}
          nextFormPath={ROUTE_MAIN_CREATE_LETTER_SUCCESS}
          previousFormPath={ROUTE_CREATE_LETTER_TEXT}
          previousFormLabel={'Шаг 3'}
          errorRedirectPath={ROUTE_MAIN_CREATE_LETTER_DEPARTMENT}
        />
      ),
    },
    {
      path: ROUTE_CREATE_LETTER_SUCCESS,
      element: <LetterSuccess isMobile={isMobile} />,
    },
    {
      path: ROUTE_CREATE_LETTER,
      element: <Navigate to={ROUTE_CREATE_LETTER_DEPARTMENT} replace={true} />,
    },
  ];

  const renderAnswerBlock = (): RouteObject[] => [
    {
      path: ROUTE_CREATE_ANSWER_DEPARTMENT,
      element: (
        <CreateFormDepartment
          tittle={'Шаг 1 из 3: Выберите учреждение'}
          mobileTittle={'1/3: Выберите учреждение'}
          previousFormPath={ROUTE_INBOX}
          previousFormLabel={'Входящие'}
          nextFormPath={ROUTE_CREATE_ANSWER_SENDER}
          isMobile={isMobile}
        />
      ),
    },
    {
      path: ROUTE_CREATE_ANSWER_SENDER,
      element: (
        <CreateFormSender
          tittle={'Шаг 2 из 3: Введите данные отправителя'}
          mobileTittle={'2/3: Введите данные отправителя'}
          nextFormPath={ROUTE_CREATE_ANSWER_PAYMENT}
          previousFormPath={ROUTE_CREATE_ANSWER_DEPARTMENT}
          previousFormLabel={'Шаг 1'}
          errorRedirectPath={ROUTE_CREATE_ANSWER}
          isMobile={isMobile}
          fromCreateAnswer={true}
        />
      ),
    },
    {
      path: ROUTE_CREATE_ANSWER_PAYMENT,
      element: isMobile ? (
        <MainCreateFormPaymentMobile
          mobileTittle={'3/3: Оплатите ответ'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_CLIENT}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          fromCreateAnswer={true}
        />
      ) : (
        <MainCreateFormPayment
          tittle={'Шаг 3 из 3: Оплатите ответ'}
          nextFormPath={ROUTE_MAIN_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_MAIN_CREATE_ANSWER_AUTHOR}
          previousFormLabel={'Шаг 2'}
          errorRedirectPath={ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT}
          fromCreateAnswer={true}
        />
      ),
    },
    {
      path: ROUTE_CREATE_ANSWER_FEEDBACK,
      element: <AnswerSuccess isMobile={isMobile} />,
    },
    {
      path: ROUTE_CREATE_FEEDBACK_SUCCESS,
      element: <AnswerFeedbackSent />,
    },
    {
      path: ROUTE_CREATE_ANSWER,
      element: <Navigate to={ROUTE_CREATE_ANSWER_DEPARTMENT} replace={true} />,
    },
  ];

  const renderReplyBlock = (): RouteObject[] => [
    {
      path: ROUTE_CREATE_REPLY_LETTER,
      element: (
        <CreateFormLetter
          tittle={'Напишите письмо'}
          mobileTittle={'Напишите письмо'}
          nextFormPath={ROUTE_CREATE_LETTER_PAYMENT}
          previousFormPath={ROUTE_INBOX}
          previousFormLabel={'Входящие'}
          errorRedirectPath={ROUTE_INBOX}
          isMobile={isMobile}
          isReply={true}
        />
      ),
    },
    {
      path: ROUTE_CREATE_REPLY_LETTER_ID,
      element: (
        <CreateFormLetter
          tittle={'Ответить на письмо'}
          mobileTittle={'Ответить на письмо'}
          nextFormPath={ROUTE_CREATE_LETTER_PAYMENT}
          errorRedirectPath={ROUTE_INBOX}
          isMobile={isMobile}
          isReply={true}
        />
      ),
    },
    {
      path: ROUTE_CREATE_REPLY_ANSWER,
      element: isMobile ? (
        <MainCreateFormPaymentMobile
          mobileTittle={'Оплатите ответ'}
          nextFormPath={ROUTE_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_CREATE_ANSWER_DEPARTMENT}
          errorRedirectPath={ROUTE_CREATE_ANSWER_DEPARTMENT}
          isMobile={isMobile}
          fromCreateAnswer={true}
          isAnswerReply={true}
        />
      ) : (
        <MainCreateFormPayment
          tittle={'Оплатите ответ'}
          nextFormPath={ROUTE_CREATE_ANSWER_FEEDBACK}
          previousFormPath={ROUTE_CREATE_ANSWER_DEPARTMENT}
          errorRedirectPath={ROUTE_CREATE_ANSWER_DEPARTMENT}
          fromCreateAnswer={true}
          isAnswerReply={true}
        />
      ),
    },
  ];

  return [
    {
      path: ROUTE_CREATE_LETTER,
      element: <LetterBlock />,
      children: renderLetterBlock(),
    },
    {
      path: ROUTE_CREATE_ANSWER,
      element: <AnswerBlock />,
      children: renderAnswerBlock(),
    },
    {
      path: ROUTE_CREATE_REPLY,
      element: <ReplyBlock />,
      children: renderReplyBlock(),
    },
    {
      path: ROUTE_CREATE,
      element: <Navigate to={ROUTE_CREATE_LETTER} replace={true} />,
    },
  ];
};
